import React, { useState } from "react";
import { Box, Button, Layer, Heading, Text, Spinner, Notification } from "grommet";
import axios from "axios";
import API_URL from "../../config/config";
import LogoutButton from "../LogoutButton";

const UpgradeToManager = ({ user_id, onUpgrade }) => {
  const [showUpgradePrompt, setShowUpgradePrompt] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpgraded, setIsUpgraded] = useState(false);
  const [error, setError] = useState("");
  const [showLogoutPrompt, setShowLogoutPrompt] = useState(false);

    const handleUpgrade = async () => {
    setIsLoading(true);
    setError(""); // Clear any previous errors

    try {
        const response = await axios.get(`${API_URL}/user/upgrade_to_manager/${user_id}`);

        if (response.status === 200) {
        console.log("User  Upgraded"); // Log successful upgrade
        setIsUpgraded(true); // Set upgraded state
        onUpgrade(); // Notify parent component if needed

        // Show success message and then prompt for logout
        setTimeout(() => {
            setShowUpgradePrompt(false); // Close upgrade confirmation
            setShowLogoutPrompt(true); // Show log-out prompt
        }, 2000); // Allow user to see success message
        } else {
        // Handle unexpected responses
        throw new Error("Unexpected server response. Please try again.");
        }
    } catch (err) {
        // Handle API errors
        const errorMessage = err.response?.data?.message || "Failed to upgrade to Manager. Please try again.";
        setError(errorMessage); // Set error message
        console.error("Upgrade error:", errorMessage); // Log the error for debugging
    } finally {
        setIsLoading(false); // Always set loading to false at the end
    }
    };

  const handleCloseAll = () => {
    setShowUpgradePrompt(false);
    setIsLoading(false);
    setIsUpgraded(false);
    setError("");
    setShowLogoutPrompt(false);
  };

  return (
    <>
      <Button
        label="Upgrade to Manager"
        onClick={() => setShowUpgradePrompt(true)}
        plain={false}
      />

      {/* Upgrade Confirmation Dialog */}
      {showUpgradePrompt && (
        <Layer
          onEsc={handleCloseAll}
          onClickOutside={handleCloseAll}
        >
          <Box pad="medium" gap="medium" width="medium">
            <Heading level="3" margin="none">
              Confirm Upgrade
            </Heading>
            <Text>Are you sure you want to upgrade to Manager?</Text>
            <Box direction="row" gap="small" justify="end">
              <Button label="Cancel" onClick={handleCloseAll} />
              <Button label="Confirm" primary onClick={handleUpgrade} />
            </Box>
          </Box>
        </Layer>
      )}

      {/* Loading Spinner */}
      {isLoading && (
        <Layer>
          <Box align="center" justify="center" pad="medium" gap="small">
            <Spinner />
            <Text>Upgrading...</Text>
          </Box>
        </Layer>
      )}

      {/* Success Notification */}
      {isUpgraded && (
        <Notification
          toast
          status="normal"
          title="Upgrade Successful!"
          message="You are now a Manager."
          onClose={() => setIsUpgraded(false)}
        />
      )}

      {/* Error Notification */}
      {error && (
        <Notification
          toast
          status="critical"
          title="Upgrade Failed"
          message={error}
          onClose={() => setError("")}
        />
      )}

      {/* Log-out Prompt */}
      {showLogoutPrompt && (
        <Layer
          onEsc={handleCloseAll}
          onClickOutside={handleCloseAll}
        >
          <Box pad="medium" gap="medium" width="medium" align="center">
            <Heading level="3" margin="none">
              Action Required
            </Heading>
            <Text>Please log out and log in again to continue.</Text>
            <LogoutButton />
          </Box>
        </Layer>
      )}
    </>
  );
};

export default UpgradeToManager;